import type { Rule } from "antd/es/form";

const ENTITY_NAME_CHARS_PATTERN = /^[a-zA-Z0-9\s\-'+]*$/;

export const ENTITY_NAME_NO_SPECIAL_CHARS_MESSAGE = "Name cannot contain special characters";

export const entityNameNoSpecialCharsRule: Rule = {
  pattern: ENTITY_NAME_CHARS_PATTERN,
  message: ENTITY_NAME_NO_SPECIAL_CHARS_MESSAGE,
};

export const ENTITY_NAME_MAX_LENGTH = 50;

export const ENTITY_NAME_MAX_LENGTH_MESSAGE = `Must not exceed ${ENTITY_NAME_MAX_LENGTH} characters.`;

export const entityNameMaxLengthRule: Rule = {
  max: ENTITY_NAME_MAX_LENGTH,
  message: ENTITY_NAME_MAX_LENGTH_MESSAGE,
};

export const divisionNameMaxLengthRule: Rule = {
  max: 30,
  message: ENTITY_NAME_MAX_LENGTH_MESSAGE
};

export const divisionEntityNameNoSpecialCharsRule: Rule = {
  pattern: ENTITY_NAME_CHARS_PATTERN,
  message: "Division name may only contain letters, numbers, spaces, hyphens, and apostrophes.",
};